import { skipToken } from '@reduxjs/toolkit/query'

import { useMaintenanceStateQuery } from '@krp/client-runtime'

import { useAppSelector } from './hooks'

/**
 * Подписка на состояние режима обновления РМК (RP-MNT), пока активна сессия: один запрос на всё приложение при старте,
 * перечитывание по событию живого канала и после восстановления связи (`composition/live.ts`). До входа запрос не идёт —
 * иначе 401 увёл бы на вход. Разметки нет: состояние кладёт в срез `maintenance` listener по ответу запроса.
 */
/** Как часто перечитывать режим обновления помимо живого канала. */
export const MAINTENANCE_POLL_MS = 30_000

export function MaintenanceMonitor() {
  const sessionActive = useAppSelector((state) => state.session.status === 'active')
  // Перечитывание раз в 30 с — касса, у которой живой канал оборвался, всё равно узнает о режиме и заблокируется: выкатка ждёт её.
  useMaintenanceStateQuery(sessionActive ? undefined : skipToken, { pollingInterval: MAINTENANCE_POLL_MS })
  return null
}
